import { useSession } from '../auth/SessionProvider.js';
import { GuideDocument } from '../help/GuideDocument.js';
import { USPS_GUIDE } from '../help/uspsGuide.js';
import { VGS_GUIDE } from '../help/vgsGuide.js';

/**
 * The reference guide for whichever side the reader is on. The VGS guide covers cost,
 * markup, and administration and is never rendered for a customer account.
 */
export function ReferenceGuidePage() {
  const { isContractor } = useSession();

  return isContractor ? (
    <GuideDocument guide={VGS_GUIDE} fileName="VGS-User-Guide.docx" />
  ) : (
    <GuideDocument guide={USPS_GUIDE} fileName="USPS-User-Guide.docx" />
  );
}
